import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useSaveDestruction = () => {
    const { mutate: saveDestruction, isLoading } = useMutation(
        async (payload) => {
            const response = await SrxApi.post('/destructions/save-destruction', payload);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message = data?.message ?? data?.data?.message ?? 'Destruction saved successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to save destruction';
                toast.error(errorMessage);
            },
        }
    );

    return { saveDestruction, isSaveDestructionLoading: isLoading };
};

export default useSaveDestruction;
